module.exports = __webpack_public_path__ + "img/lsd1.93648a2c.png";